import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, InputAdornment, Icon, TextField, Grid } from '@material-ui/core';

import ReCAPTCHA from "react-google-recaptcha";

class ForgetPasswordDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    this.ReCAPTCHARef = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      username: "",
      email: "",
      user_id: "",
    };
    autoBind(this);
  }

  handleClose() {
    this.props.parent.setState({forgetPasswordDialogOpen: false});
    this.props.parent.state.forgetPasswordDialogOpen = false;
  }

  btnCancelClicked() {
    this.handleClose();
  }

  btnOKClicked() {
    if (this.validateInput) {
      let requestObj = {
        username: this.state.username.trim()
      };
      this.props.root.refs.API.request("check_username_exists", requestObj, this.check_username_existsOK, this.check_username_existsFailed);
    }
  }

  check_username_existsOK(res) {
    switch(res.body['result']){
      case 0:
        this.props.root.addNotification("No email is registered for this account. Please contact 'clst@fed.cuhk.edu.hk' for further information.");
        break;
      default:
        this.setState({
          user_id: res.body['result']
        });
        this.state.user_id = res.body['result'];
        this.ReCAPTCHARef.current.execute();
        break;
    }
  }

  check_username_existsFailed(err) {
    this.props.root.addNotification("Account assiociated with this username does not exist.");
  }

  usernameChanged(e) {
    this.setState({
      username: e.target.value
    });
    this.state.username = e.target.value;
  }

  emailChanged(e) {
    this.setState({
      email: e.target.value
    });
    this.state.email = e.target.value;
  }

  validateInput() {
    let result = true;

    if (this.state.username.trim() == "" || this.state.email.trim() == "") {
      result = false;
    }

    return result;
  }

  onRECAPTCHAChange(value) {
    console.log("CAPTCHA value: " + value);
    // send email to user
    let requestObj = {
      user_id: this.state.user_id,
      captcha_value: value
    }
    this.props.root.refs.API.request("send_password_reset_email", requestObj, this.send_password_reset_emailOK, this.send_password_reset_emailFailed);
  }

  send_password_reset_emailOK(res) {
    console.log(res.body['result']);
    //0, email cannot be sent, 1 everything good, -1, captcha failed
    switch(res.body['result']){
      case 0:
        this.props.root.addNotification("Email cannot be sent. Please try again later.");
        break;
      case 1:
        this.props.root.addNotification("Email has been sent. Please check your email.");
        this.handleClose();
        break;
      case -1:
        this.props.root.addNotification("Captcha failed. Please try again.");
        break;
      default:
        this.props.root.addNotification("Error.");
        break;
    }
    this.handleClose();
  }

  send_password_reset_emailFailed(err) {
    console.log(err);
    this.props.root.addNotification("Failed to send password reset email.");
    this.handleClose();
  }

  render() {
      return (
        <div>
          <Dialog
            open={this.props.parent.state.forgetPasswordDialogOpen}
            onClose={this.handleClose}
          >
            <DialogTitle>
              Forgot Password
            </DialogTitle>
            <DialogContent>
              A new password will be sent to the email that associates with the corresponding username.
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label={Localization.strings.USERNAME}
                    value={this.state.username}
                    onChange={this.usernameChanged}
                    InputProps={{
                      endAdornment: <InputAdornment position="end"><Icon>account_circle</Icon></InputAdornment>
                    }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{padding:'16px 24px'}}>
              <Button onClick={this.btnCancelClicked}>{Localization.strings.CANCEL}</Button>
              <Button
                onClick={this.btnOKClicked}
                color="primary"
                variant="contained"
              >
                OK
                <ReCAPTCHA
                  ref={this.ReCAPTCHARef}
                  size="invisible"
                  sitekey="6LdgWnggAAAAAMPfDdnQQyYjHZrLOe0NA7aNDdTn"
                  onChange={this.onRECAPTCHAChange}
                />
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
  }
}

export default ForgetPasswordDialog;
